module.exports = __webpack_public_path__ + "img/mg-jp.b5fde450.png";